import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import './../shared/rxjs-operators';
import { ApiService, Plan, CacheService, AppContext } from './../shared';

@Injectable()
export class WebSearchService {
  plans: Observable<Plan[]>;
  code: string = '';
  // subscription: Subject<string>;
  constructor(private api: ApiService, private cache: CacheService, public app: AppContext) {
  }

  // Variable being used as place holder untill we can check the billing interval through appContext
  public monthlyAccount = true;
  // End - Variable being used as place holder untill we can check the billing interval through appContext


  getPlans(): Observable<Plan[]> {
    let cache = this.cache.get('plans');

    let promise = this.api.getApiClient().then(client => this.callGetPlans(client));
    let server = Observable.fromPromise(promise);

    this.plans = Observable.concat(cache, server);
    this.cache.updateCache('plans', this.plans);

    return this.plans;
  }

  callGetPlans(apigClient): Promise<Plan[]> {
    return new Promise((resolve, reject) => {
      let params = {
      };

      let body = {
        // This is where you define the body of the request,
      };

      let additionalParams = {
        // If there are any unmodeled query parameters or headers that must be 
        // sent with the request, add them here.
        headers: {
          'Content-Type': 'application/json'
        },
        queryParams: {

        }
      }
      try {
        apigClient.billingPlansGet(params, '', additionalParams)
          .then((result) => {
            let planArray = new Array<Plan>();
            for (let current = 0; current < result.data.data.length; current++) {
              let plan = new Plan(result.data.data[current]);
              planArray.push(plan);
            }
            resolve(planArray);
          })
          .catch((err) => {
            return reject(err);
          })
      }
      catch (ex) {
        return reject(ex);
      }
    });
  }
  public yearlyBilling = false;

  public managementShowFull = false;

  expandManagement() {
    this.managementShowFull = !this.managementShowFull;
  }

  public capacityShowFull = false;

  expandCapacity() {
    this.capacityShowFull = !this.capacityShowFull;
  }

  public constructionShowFull = false;

  expandConstruction() {
    this.constructionShowFull = !this.constructionShowFull;
  }

  public propulsionShowFull = false;

  expandPropulsion() {
    this.propulsionShowFull = !this.propulsionShowFull;
  }

  isEnterprise() {
    if (this.app.accountType == 'Professional') {
      if (this.app.plan.name == 'Professional' || this.app.plan.name == 'Monthly API 500' || this.app.plan.name == 'Monthly API 1000' || this.app.plan.name == 'Monthly API 4000' || this.app.plan.name == 'Monthly API 15000') {
        return false;
      } else if (this.app.plan.name == 'Monthly Enterprise 2-6' || this.app.plan.name == 'Monthly Enterprise 7-12' || this.app.plan.name == 'Monthly Enterprise 13-18' || this.app.plan.name == 'Yearly Enterprise 2-6' || this.app.plan.name == 'Yearly Enterprise 7-12' || this.app.plan.name == 'Yearly Enterprise 13-18') {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  isMontylyEnterprise() {
    if (this.app.plan.name == 'Monthly Enterprise 2-6' || this.app.plan.name == 'Monthly Enterprise 7-12' || this.app.plan.name == 'Monthly Enterprise 13-18') {
      return true;
    } else {
      return false;
    }
  }

  isYearlyEnterprise() {
    if (this.app.plan.name == 'Yearly Enterprise 2-6' || this.app.plan.name == 'Yearly Enterprise 7-12' || this.app.plan.name == 'Yearly Enterprise 13-18') {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/web-search/web-search.service.ts